export default "__VITE_ASSET__D3u3PZoN__"